import { TypeEnum } from "../../shared/widgets/Form/enums/TypeEnum";
import { IForm } from "../../shared/widgets/Form/models/Form.model";

export const ToolsCreateForm: IForm[] = [
  {
    label: "Function",
    field: "function",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Language",
    field: "language",
    value: "python",
    options: [
      { label: "Python", value: "python" },
      { label: "Javascript", value: "javascript" },
    ],
    type: TypeEnum.Dropdown,
  },
  {
    label: "Tool Config",
    field: "toolConfig",
    lang: "python",
    value: "",
    type: TypeEnum.Config,
  },
];
